import { render, staticRenderFns } from "./downTime.vue?vue&type=template&id=0ed69bfe&scoped=true"
import script from "./downTime.vue?vue&type=script&lang=js"
export * from "./downTime.vue?vue&type=script&lang=js"
import style0 from "./downTime.vue?vue&type=style&index=0&id=0ed69bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed69bfe",
  null
  
)

export default component.exports